import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrediccionComponent } from './prediccion/prediccion.component';
import { ComprasComponent } from './compras/compras.component';
import { AuthGuard } from 'app/auth/helpers';
import { RouterModule } from '@angular/router';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { TranslateModule } from '@ngx-translate/core';
import { CoreCommonModule } from '@core/common.module';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';


const routes = [
  {
    path: 'pronostico/prediccion',
    component: PrediccionComponent,
    data: { animation: 'activos' },
    canActivate: [AuthGuard]
  }
];

@NgModule({
  declarations: [ PrediccionComponent, ComprasComponent ],
  imports: [RouterModule.forChild(routes), ContentHeaderModule, TranslateModule, CoreCommonModule, NgbAlertModule],
  exports: [ PrediccionComponent, ComprasComponent ]
})
export class PronosticoModule { }
